<div class="screen screen--home">

  <!-- Greeting. The accommodation badge used to sit in the top-right corner;
       that corner now holds the shell's floating menu button (<top-menu>),
       which every screen needs, and the tenant logo lives in the drawer head. -->
  <header class="home__header">
    <p class="belturo-eyebrow"><%= region %></p>
    <h1 class="home__greeting"><%= name ? _lcs( 'Hallo {name},', { name: name } ) : _lcs( 'Hallo,' ) %><br /><%= _lcs( 'schön dass du da bist.' ) %></h1>
  </header>

  <!-- Tenant welcome image (theme.welcomeImageUrl) — only when uploaded -->
  <% if ( welcomeImageUrl ) { %>
  <figure class="home__welcome">
    <img src="<%= welcomeImageUrl %>" alt="<%= shortName %>" loading="lazy" />
  </figure>
  <% } %>

  <!-- Weather. Both cards open the forecast sheet; the values are patched in
       place by HomeState once core/Weather.js resolves (it paints from the
       local cache first, so this is usually already the real temperature). -->
  <div class="home__stats">
    <button class="statcard" type="button" data-id="weather-card" aria-label="<%= _lcs( 'Wetter und Vorhersage' ) %>">
      <i class="icon icon--<%= weather.icon %> statcard__icon statcard__icon--sand" data-id="weather-icon"></i>
      <div class="statcard__text">
        <div class="statcard__value" data-id="weather-temp"><%= weather.temp %></div>
        <div class="statcard__meta" data-id="weather-meta"><%= weather.meta %></div>
      </div>
    </button>
    <button class="statcard" type="button" data-id="weather-details">
      <i class="icon icon--calendar-days statcard__icon statcard__icon--green"></i>
      <div class="statcard__text">
        <div class="statcard__value statcard__value--sm"><%= _lcs( 'Vorhersage' ) %></div>
        <div class="statcard__meta"><%= _lcs( '7 Tage & Details' ) %></div>
      </div>
    </button>
  </div>

  <!-- House info: the digital Gästemappe (dynamic — maintained in the client-admin) -->
  <button class="infocard" type="button" data-id="info">
    <span class="infocard__icon"><i class="icon icon--book-open"></i></span>
    <span class="infocard__text">
      <span class="infocard__title"><%= _lcs( 'Gästemappe' ) %></span>
      <span class="infocard__sub"><%= mappeSub %></span>
    </span>
    <i class="icon icon--chevron-right infocard__chev"></i>
  </button>

  <!-- Quick actions: a random handful of the Gästemappe's modules, each opening
       straight onto its spot in the Gästemappe. Left out when there are none. -->
  <% if ( actions.length > 0 ) { %>
  <div class="section-head"><h3><%= _lcs( 'Schnellzugriff' ) %></h3></div>
  <div class="qa-grid">
    <% actions.forEach( function( a ) { %>
      <button class="qa" type="button" data-block="<%= a.blockId %>">
        <span class="qa__icon qa__icon--<%= a.tone %>"><i class="icon icon--<%= a.icon %>"></i></span>
        <span class="qa__label"><%= a.label %></span>
        <span class="qa__sub"><%= a.sub %></span>
      </button>
    <% } ); %>
  </div>
  <% } %>

  <!-- Next event -->
  <% if ( today ) { %>
  <div class="section-head">
    <h3><%= _lcs( 'Als Nächstes' ) %></h3>
    <button class="section-head__link" type="button" data-id="all-events"><%= _lcs( 'Alle Events' ) %></button>
  </div>
  <button class="eventmini" type="button" data-id="today">
    <span class="datechip">
      <span class="datechip__day"><%= today.day %></span>
      <span class="datechip__mon"><%= today.mon %></span>
    </span>
    <span class="eventmini__text">
      <span class="eventmini__title"><%= today.title %></span>
      <span class="eventmini__meta"><%= [ today.time ? _lcs( '{time} Uhr', { time: today.time } ) : ( today.allDay ? _lcs( 'ganztägig' ) : '' ), today.loc, today.dist ].filter( Boolean ).join( ' · ' ) %></span>
    </span>
    <% if ( today.badge ) { %><span class="badge badge--accent badge--sm"><%= today.badge %></span><% } %>
  </button>
  <% } %>

  <!-- Recommendations — the host's own picks. Hidden until the fetch resolves,
       and left hidden when they have picked nothing: an empty rail under a
       heading reads as "your host recommends nothing". -->
  <section data-id="recos" hidden>
    <div class="section-head">
      <h3><%= _lcs( 'Empfehlungen für dich' ) %></h3>
      <button class="section-head__link" type="button" data-id="recos-all" hidden><%= _lcs( 'Alle' ) %></button>
    </div>
    <div class="rail" data-id="recos-rail"></div>
  </section>

</div>
